export default {
  about: 'a-propos',
  home: 'accueil',
  langs: {
    en: 'English',
    fr: 'Français',
    it: 'Italiano',
  },
}
